import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const GoogleOAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = () => {
      const code = searchParams.get('code');
      const state = searchParams.get('state');
      const error = searchParams.get('error');

      // Check if we're in a popup context
      if (window.opener) {
        if (error) {
          window.opener.postMessage({
            type: 'GOOGLE_AUTH_ERROR',
            error: error || 'OAuth authentication failed'
          }, window.location.origin);
        } else if (code) {
          window.opener.postMessage({
            type: 'GOOGLE_AUTH_SUCCESS',
            code: code,
            state: state
          }, window.location.origin);
        } else {
          window.opener.postMessage({
            type: 'GOOGLE_AUTH_ERROR',
            error: 'No authorization code received'
          }, window.location.origin);
        }
        
        // Close the popup
        window.close();
      } else {
        // Not in popup, redirect to login page
        if (error) {
          navigate(`/login?error=${encodeURIComponent(error)}`);
        } else {
          navigate('/login');
        }
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Completing Google Sign-in...</h2>
        <p className="text-gray-600">Please wait while we complete your authentication.</p>
      </div>
    </div>
  );
};

export default GoogleOAuthCallback;